import { EllipsisVertical } from "lucide-react";
import ConsultantDropdown from "./ConsultantDropdown";
const ConsultantCard = ({ consultantId, img, name, title }: { img?: string; name?: string; title?: string; consultantId: string; }) => {


    return (
        <div className="shadow-sm bg-white rounded-xl p-8 flex flex-col items-center justify-center h-[289px] bg-teamPattern relative">
            <img src={img} className="size-[110px] rounded-full object-cover object-[75%_25%] mb-6" alt="" />
            <h1 className="mb-1">{name}</h1>
            <p>{title}</p>
            <div className="absolute bottom-2 right-2 z-10">

                <ConsultantDropdown consultantId={consultantId}>
                    <EllipsisVertical size={28} />
                </ConsultantDropdown>
            </div>


        </div>
    )
}

export default ConsultantCard